<div class="payee-mini-icon-button-wrapper">
  <ng-content select="img,payee-icon,mat-icon"></ng-content>
</div>
<span
  payee-ripple
  [payeeRippleDisabled]="disableRipple"
  [payeeRippleTrigger]="element"
  [attr.color]="color()"
></span>
